// Styles
import './products-carousel.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFeaturedCarousel = (context) => {

  const carousel_banner = context.closest('.shopify-section');

  if (carousel_banner) {
    const slider = carousel_banner.querySelector('[data-products-carousel-master]');

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 4,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
        snapOnRelease: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        }
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.products-carousel__blocks-container.carousel-container'), (el) => {
    window.dAgency.initFeaturedCarousel(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.products-carousel__blocks-container.carousel-container'), (el) => {
      window.dAgency.initFeaturedCarousel(el);
    });
  });
}
